import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";

interface ILegalEntity {
  id: number;
  name: string;
  value: string;
}

interface ILegalEntitiesResponse {
  data: ILegalEntity[];
  message: string;
  status: boolean;
  status_code: number;
}

export const fetchLegalEntities = async (): Promise<ILegalEntitiesResponse> => {
  const { data } = await getData(ajaxEndpoints.LEGAL_ENTITIES);
  return data;
};

const useLegalEntities = () => {
  return useQuery<ILegalEntitiesResponse>(
    ["legalEntities"],
    fetchLegalEntities,
    {
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
      refetchOnWindowFocus: false,
    }
  );
};

export default useLegalEntities;
